export var TextFieldClassName;
(function (TextFieldClassName) {
    TextFieldClassName["OmitStartAdornmentSpacing"] = "ap-omit-start-adornment-spacing";
})(TextFieldClassName || (TextFieldClassName = {}));
